import Cookies from "js-cookie";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {routes, useGetDataById} from "../routes/api";
import React, {useContext, useEffect, useLayoutEffect, useState} from "react";
import {BEIssueComponent, LoadingComponent, NoDataComponent} from "../util/loading";
import {Card, CardContent, CardHeader, Grid, IconButton} from "@mui/material";
import {organizationFields} from "../util/modelFields";
import NavigateBreadcrumbs from "../components/navBreadcrumbs";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import ContentDetail from "../components/contentDetail";
import {updateData} from "../util/util";
import {OrganizationHeaders} from "../util/getFields";
import {EnumContext} from "../components/enumContext";
import Button from "@mui/material/Button";
import PopupDialog from "../components/popupDialog";
import OrganizationRelationEdit from "./orgRelationEdit";


export default function OrganizationDetail() {
    const token = Cookies.get('token');
    const route = routes.organization;
    const {id} = useParams();
    const permissions = Cookies.get('permissions') ?
        JSON.parse(Cookies.get('permissions')).organization :
        {create: false, edit: false, delete: false, view: false};
    const webAdmin = Cookies.get('webAdmin') === 'T';
    const {enums} = useContext(EnumContext);

    const [backendIssue, setBackendIssue] = useState(false);
    const [noData, setNoData] = useState(false);
    const [newData, setNewData] = useState({});
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);

    const {data, loading, statusCode, handleCall} = useGetDataById(token, route, id || '0');

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from ? location.state.from : {pathname: `/`};

    useEffect(() => {
        if ((statusCode === 404 || statusCode === 421)) {
            if (!id) {
                setNoData(true);
            } else {
                navigate('/organization');
            }
        } else if (statusCode >= 400 && statusCode < 500) {
            navigate('/');
        } else if (statusCode >= 500) {
            setBackendIssue(true);
        } else if (JSON.stringify(data) !== '{}') {
            setNewData(updateData(data.data, OrganizationHeaders, 'o', enums));
        }
    }, [statusCode, data]);

    const fetchDetail = async () => {
        try {
            await handleCall({});
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useLayoutEffect(() => {
        if (!(permissions.view || webAdmin)) {
            navigate(from);
        } else {
            fetchDetail();
        }
    }, []);

    if (backendIssue) return <BEIssueComponent/>;

    if (noData) return <Grid
        container
        spacing={2}
        alignItems="stretch"
        justifyContent="center"
        sx={{margin: 'auto', mt: 5, width: '80%'}}
    >
        <Grid size={12}>
        </Grid>
        <Grid size={12} key="nav">
            <NavigateBreadcrumbs alias='organization' display='Organization'/>
        </Grid>
        <Grid size={8} sx={{mb: 3}}>
            <Typography variant='h4'>Organization</Typography>
        </Grid>
        <Grid size={4} sx={{mb: 3, display: "flex", justifyContent: "flex-end"}}>
            {/*{webAdmin &&*/}
            {/*    <Button variant="contained" onClick={() => setOpen(true)}*/}
            {/*            startIcon={<EditIcon/>}>*/}
            {/*        Edit*/}
            {/*    </Button>}*/}
        </Grid>
        <Grid size={12}>
            <NoDataComponent message="User is not in an organization"/>
        </Grid>
        <PopupDialog
            open={open}
            display='Edit Organization Data'
            content={
                <OrganizationRelationEdit
                    id={data.id}
                    orgName={newData.o_name}
                />}
            handleClose={() => setOpen(false)}
        />
    </Grid>

    if (loading || Object.keys(newData).length === 0) return <LoadingComponent/>;

    return <Grid
        container
        spacing={2}
        alignItems="stretch"
        justifyContent="center"
        sx={{margin: 'auto', mt: 5, width: '80%'}}
    >
        <Grid size={12}>
        </Grid>
        <Grid size={12} key="nav">
            <NavigateBreadcrumbs alias='organization' display='Organization' id={newData.o_name}/>
        </Grid>
        <Grid size={8} sx={{mb: 3}}>
            <Typography variant='h4'>{newData.o_name}</Typography>
        </Grid>
        <Grid size={4} sx={{mb: 3, display: "flex", justifyContent: "flex-end"}}>
            {webAdmin &&
                <Button variant="contained" onClick={() => setOpen(true)}
                        startIcon={<EditIcon/>}>
                    Edit Members & Assets
                </Button>}
        </Grid>
        <Grid size={12}/>
        <Grid size={12} key="org-detail" sx={{display: 'flex'}}>
            <Card sx={{borderRadius: '16px', width: '100%', height: '100%', padding: 2, paddingBottom: 0}}>
                <CardHeader
                    action={(permissions.edit || webAdmin) ?
                        <IconButton onClick={() => setEdit(!edit)}>
                            <EditIcon/>
                        </IconButton> :
                        null
                    }
                    title='Details'
                />
                <CardContent>
                    <ContentDetail
                        alias='organization'
                        id={newData.id}
                        data={newData}
                        edit={edit}
                        setEdit={setEdit}
                        refresh={fetchDetail}
                        fields={organizationFields}
                    />
                </CardContent>
            </Card>
        </Grid>
        <PopupDialog
            open={open}
            display={`Edit ${data.data.o_name} Members & Assets`}
            content={
                <OrganizationRelationEdit
                    orgData={data.relations}
                    id={data.data.id}
                    refresh={fetchDetail}
                />}
            handleClose={() => setOpen(false)}
        />
    </Grid>
}